import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import Marquee from "../components/site/Marquee";
import Manifesto from "../components/site/Manifesto";
import Catalog from "../components/site/Catalog";
import Enquiry from "../components/site/Enquiry";
import Footer from "../components/site/Footer";
import WhatsAppButton from "../components/site/WhatsAppButton";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      setTimeout(() => document.getElementById(target)?.scrollIntoView({ behavior: "smooth" }), 400);
    }
  }, [location.state]);

  return (
    <div className="grain">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Catalog />
        <Enquiry />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
